/**
 * Recruitment workflow step 5c — the `?next=` redirect after sign-in (the invite page sends a
 * candidate to `/signin?next=/job-seekers/<slug>`).
 *
 * Only same-site paths are accepted, so the parameter can't be used as an open redirect: it must
 * start with a single `/`, and `//host` or `/\host` (which browsers treat as another origin) are
 * rejected. Anything else returns null and the caller falls back to its default.
 */
export function safeNextPath(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const value = raw.trim();
  if (!value.startsWith('/')) return null;
  if (value.startsWith('//') || value.startsWith('/\\')) return null;
  // Control characters (e.g. a tab or newline inside "/\t/evil.com") are stripped by URL
  // parsers and could re-form "//"; refuse them outright.
  for (let i = 0; i < value.length; i++) {
    const code = value.charCodeAt(i);
    if (code < 0x20 || code === 0x7f) return null;
  }
  return value;
}
